(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initAnn() {
    qsa('[data-cl-ann]').forEach(function (root) {
      var msgs = qsa('.cl-ann__msg', root);
      if (msgs.length < 2) return;
      var i = 0;
      var speed = parseInt(root.getAttribute('data-speed') || '4000', 10);
      window.setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, speed);
    });
  }

  function initHeader() {
    var header = qs('[data-cl-header]');
    if (!header) return;
    var burger = qs('[data-cl-burger]', header);
    var drawer = qs('[data-cl-drawer]');
    var scrim = qs('[data-cl-scrim]');
    var closeBtn = qs('[data-cl-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-on');
      if (scrim) scrim.classList.add('is-on');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cl-nav-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-on');
      if (scrim) scrim.classList.remove('is-on');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cl-nav-open');
      document.body.style.overflow = '';
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', function () {
      closeDrawer();
      closeSearch();
    });
    qsa('a', drawer).forEach(function (a) { a.addEventListener('click', closeDrawer); });

    var searchBtn = qs('[data-cl-search-open]', header);
    var searchDrop = qs('[data-cl-search]');
    var searchInput = searchDrop ? qs('input[type="search"]', searchDrop) : null;
    var searchClose = searchDrop ? qs('[data-cl-search-close]', searchDrop) : null;
    var results = searchDrop ? qs('[data-cl-search-results]', searchDrop) : null;
    var searchTimer = null;

    function openSearch() {
      if (!searchDrop) return;
      searchDrop.hidden = false;
      header.classList.add('is-search-open');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 30);
    }
    function closeSearch() {
      if (!searchDrop) return;
      searchDrop.hidden = true;
      header.classList.remove('is-search-open');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    }
    if (searchBtn) searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (searchDrop.hidden) openSearch(); else closeSearch();
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    function renderHits(products) {
      if (!results) return;
      if (!products || !products.length) {
        results.innerHTML = '<p class="cl-search-empty">No matches yet. Try oils, capsules or balm.</p>';
        return;
      }
      results.innerHTML = products.map(function (p) {
        var img = p.image ? '<img class="cl-search-hit__img" src="' + p.image + '" alt="" width="44" height="44">' : '';
        var price = p.price || '';
        return '<a class="cl-search-hit" href="' + p.url + '">' + img + '<span class="cl-search-hit__tx"><b>' + p.title + '</b><span>' + price + '</span></span></a>';
      }).join('');
    }

    function search(q) {
      if (!window.routes || !window.routes.predictive_search_url) return;
      var url = window.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var bucket = (((data || {}).resources || {}).results) || {};
          var products = bucket.products || [];
          var pages = (bucket.pages || []).concat(bucket.articles || []);
          var rows = products.map(function (p) {
            return { title: p.title, url: p.url, image: p.image || (p.featured_image && p.featured_image.url) || '', price: p.price || '' };
          });
          pages.slice(0, 3).forEach(function (p) {
            rows.push({ title: p.title, url: p.url, image: '', price: p.type || 'Page' });
          });
          renderHits(rows);
        })
        .catch(function () {
          if (results) results.innerHTML = '';
        });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim();
        window.clearTimeout(searchTimer);
        if (q.length < 2) {
          if (results) results.innerHTML = '';
          return;
        }
        searchTimer = window.setTimeout(function () { search(q); }, 180);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
        closeSearch();
      }
    });

    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initSliders() {
    qsa('[data-cl-slider]').forEach(function (root) {
      var track = qs('[data-cl-track]', root);
      if (!track) return;
      var prev = qs('[data-cl-prev]', root);
      var next = qs('[data-cl-next]', root);
      var bar = qs('[data-cl-bar] i', root);
      function step() {
        var item = track.querySelector('li');
        return item ? item.getBoundingClientRect().width + 16 : 280;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        if (bar) {
          bar.style.width = '28%';
          bar.style.transform = 'translateX(' + (ratio * 250) + '%)';
        }
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initExplore() {
    var fine = window.matchMedia('(hover: hover) and (min-width: 990px)');
    qsa('[data-cl-explore]').forEach(function (root) {
      var tiles = qsa('.cl-cs__p', root);
      function activate(tile) {
        if (!fine.matches) return;
        tiles.forEach(function (t) { t.classList.remove('is-on'); });
        tile.classList.add('is-on');
      }
      tiles.forEach(function (tile) {
        tile.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'touch') return;
          activate(tile);
        });
        tile.addEventListener('focusin', function () { activate(tile); });
      });
    });
  }

  function initFaq() {
    qsa('.cl-acc').forEach(function (acc) {
      qsa('details', acc).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          qsa('details', acc).forEach(function (other) {
            if (other !== d) other.open = false;
          });
        });
      });
    });
  }

  function money(cents) {
    var format = (window.clTheme && window.clTheme.moneyFormat) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function setCartCount(n) {
    qsa('[data-cl-cart-count]').forEach(function (el) { el.textContent = String(n); });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function initProduct() {
    var root = qs('[data-cl-product-form]');
    if (!root) return;
    var form = root.matches && root.matches('form') ? root : qs('form', root);
    if (!form) return;
    var variantsEl = qs('[data-cl-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (e) { variants = []; }
    var idInput = qs('input[name="id"]', form);
    var priceEl = qs('[data-cl-price]');
    var imgEl = qs('[data-cl-pdp-img]');
    var note = qs('[data-cl-note]');
    var submit = qs('[data-cl-add]', form);

    function selectedOptions() {
      var opts = [];
      qsa('[data-cl-option]', form).forEach(function (group) {
        var on = qs('.is-on', group);
        opts.push(on ? on.getAttribute('data-value') : null);
      });
      return opts;
    }

    function matchVariant() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return (!opts[0] || v.option1 === opts[0]) && (!opts[1] || v.option2 === opts[1]) && (!opts[2] || v.option3 === opts[2]);
      }) || variants[0];
    }

    function mgFromText(text) {
      var match = String(text || '').match(/(\d+(?:\.\d+)?)\s*mg/i);
      return match ? parseFloat(match[1]) : 0;
    }

    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_fmt || money(v.price);
      if (v.image && window.clGalShowMedia && window.clGalShowMedia(v.media_id, v.image)) {
        // switched gallery to the variant's own slide
      } else if (imgEl && v.image) {
        imgEl.src = v.image;
        var slide = imgEl.closest('[data-cl-gal-slide]');
        if (slide) slide.setAttribute('data-full', v.image);
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? (submit.getAttribute('data-label') || 'Add to basket') : 'Sold out';
      }
      var sticky = qs('[data-cl-sticky-add]');
      if (sticky) sticky.textContent = v.available ? (submit ? submit.getAttribute('data-label') : 'Add to basket') : 'Sold out';
      var stickyPrice = qs('[data-cl-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = v.price_fmt || money(v.price);
      var priceRow = priceEl ? priceEl.parentElement : null;
      var mg = 0;
      var strength = '';
      [v.option1, v.option2, v.option3].forEach(function (option) {
        var found = mgFromText(option);
        if (found) {
          mg = found;
          strength = option;
        }
      });
      if (!mg && priceRow) mg = parseFloat(priceRow.getAttribute('data-base-mg') || '0') || 0;
      if (!strength && priceRow) strength = priceRow.getAttribute('data-strength') || '';
      var per = qs('[data-cl-permg]');
      if (per) {
        if (mg > 0 && v.price) {
          per.hidden = false;
          per.textContent = money(Math.round(v.price / mg)) + ' / mg';
        } else {
          per.hidden = true;
        }
      }
      var pill = qs('[data-cl-strength]');
      if (pill) {
        if (strength) {
          pill.hidden = false;
          pill.textContent = strength;
        } else {
          pill.hidden = true;
        }
      }
    }

    qsa('[data-cl-option] button', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-cl-option]');
        qsa('button', group).forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        applyVariant(matchVariant());
      });
    });

    var qty = qs('[data-cl-qty]', form);
    if (qty) {
      var input = qs('input', qty);
      qsa('button', qty).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-dir'), 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
          input.value = String(next);
        });
      });
    }

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (!submitter || !submitter.hasAttribute('data-cl-add')) return;
      e.preventDefault();
      if (note) { note.textContent = ''; note.className = 'cl-note'; }
      var body = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (note) {
              note.textContent = (res.data && res.data.description) || 'Could not add that item.';
              note.classList.add('is-error');
            }
            return;
          }
          if (note) {
            note.textContent = 'Added to your basket.';
            note.classList.add('is-ok');
          }
          refreshCartCount();
        })
        .catch(function () {
          form.submit();
        });
    });

    var sticky = qs('[data-cl-sticky-add]');
    if (sticky && submit) sticky.addEventListener('click', function () { if (!submit.disabled) submit.click(); });

    var buyBtn = submit;
    if (buyBtn && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        var onScreen = entries[0] && entries[0].isIntersecting;
        document.body.classList.toggle('cl-atc-stuck', !onScreen);
      }, { threshold: 0.15 });
      obs.observe(buyBtn);
    }
  }

  function initGallery() {
    var gal = qs('[data-cl-gal]');
    if (!gal) return;
    var stage = qs('.cl-gal__stage', gal);
    var slides = qsa('[data-cl-gal-slide]', gal);
    var thumbs = qsa('[data-cl-gal-thumb]', gal);
    var current = 0;
    var lock = false;
    function scrollable() { return stage && stage.scrollWidth > stage.clientWidth + 4; }
    function mark(index) {
      current = index;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-on', i === index); });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-on', i === index);
        thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      var t = thumbs[index];
      var bar = t && t.parentElement;
      if (bar && bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: Math.max(0, t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
      }
    }
    function show(index) {
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      mark(index);
      if (scrollable()) {
        lock = true;
        stage.scrollTo({ left: slides[index].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        setTimeout(function () { lock = false; }, 600);
      }
    }
    window.clGalShowMedia = function (mediaId, src) {
      var idx = -1;
      if (mediaId) slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) idx = i; });
      if (idx < 0 && src) {
        var base = String(src).split('?')[0];
        slides.forEach(function (s, i) { var im = qs('img', s); if (im && im.src.split('?')[0] === base) idx = i; });
      }
      if (idx >= 0) { show(idx); return true; }
      return false;
    };
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { show(index); });
    });
    if (stage) {
      var raf = 0;
      stage.addEventListener('scroll', function () {
        if (lock || !scrollable()) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
          if (i !== current && slides[i]) mark(i);
        });
      }, { passive: true });
      var sx = null, sy = 0, moved = false;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (scrollable()) return;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { moved = true; show(current + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
      stage.addEventListener('click', function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
    }
    var dialog = qs('[data-cl-zoom-dialog]', gal);
    slides.forEach(function (slide) {
      slide.addEventListener('click', function () {
        if (!dialog || !dialog.showModal) return;
        var full = slide.getAttribute('data-full');
        var img = qs('img', dialog);
        if (img && full) img.src = full;
        dialog.showModal();
      });
    });
    if (dialog) {
      var closer = qs('[data-cl-zoom-close]', dialog);
      if (closer) closer.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  function initCart() {
    var root = qs('[data-cl-cart]');
    if (!root) return;
    qsa('[data-cl-line]', root).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var input = qs('input', line);
      function change(qty) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function () { window.location.reload(); });
      }
      qsa('button[data-dir]', line).forEach(function (b) {
        b.addEventListener('click', function () {
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-dir'), 10));
          change(next);
        });
      });
      var remove = qs('[data-cl-remove]', line);
      if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); change(0); });
    });
  }

  function initPopup() {
    var pop = qs('[data-cl-pop]');
    if (!pop || window.Shopify && window.Shopify.designMode) return;
    if (pop.getAttribute('data-success') === 'true') return;
    var key = 'cl_pop_dismiss_v2';
    try {
      var until = parseInt(localStorage.getItem(key) || '0', 10);
      if (until && Date.now() < until) return;
    } catch (e) {}
    var scrim = qs('[data-cl-pop-scrim]');
    var opened = false;
    function dismiss() {
      pop.classList.remove('is-on');
      if (scrim) scrim.classList.remove('is-on');
      window.setTimeout(function () {
        pop.hidden = true;
        if (scrim) scrim.hidden = true;
      }, 280);
      try { localStorage.setItem(key, String(Date.now() + 10 * 864e5)); } catch (e) {}
    }
    function open() {
      if (opened) return;
      opened = true;
      pop.hidden = false;
      if (scrim) scrim.hidden = false;
      window.requestAnimationFrame(function () {
        pop.classList.add('is-on');
        if (scrim) scrim.classList.add('is-on');
      });
    }
    var closer = qs('[data-cl-pop-close]', pop);
    if (closer) closer.addEventListener('click', dismiss);
    if (scrim) scrim.addEventListener('click', dismiss);
    var delay = parseInt(pop.getAttribute('data-delay') || '4500', 10);
    var timer = window.setTimeout(open, delay);
    window.addEventListener('scroll', function onScroll() {
      if (window.scrollY > 220) {
        window.clearTimeout(timer);
        open();
        window.removeEventListener('scroll', onScroll);
      }
    }, { passive: true });
  }

  function initHero() {
    qsa('[data-cl-hero]').forEach(function (root) {
      var slides = qsa('[data-cl-slide]', root);
      if (!slides.length) return;
      var index = 0;
      var dots = qsa('[data-cl-dot]', root);
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-speed') || '6000', 10);
      var timer = null;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var on = i === index;
          slide.classList.toggle('is-on', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-on', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      function start() {
        if (timer) window.clearInterval(timer);
        if (!autoplay || slides.length < 2 || reduce) return;
        timer = window.setInterval(function () { show(index + 1); }, speed);
      }
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }
      var prev = qs('[data-cl-hero-prev]', root);
      var next = qs('[data-cl-hero-next]', root);
      if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); start(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { show(i); start(); });
      });
      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { show(index + 1); start(); }
        if (event.key === 'ArrowLeft') { show(index - 1); start(); }
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) start();
      });
      var startX = 0;
      root.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].clientX;
      }, { passive: true });
      root.addEventListener('touchend', function (event) {
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) < 42) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      }, { passive: true });
      show(0);
      start();
    });
  }

  function initRichText() {
    var re = /^[\s\u200d\ufe0f]*(?:[\u2190-\u2BFF\u2600-\u27BF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])[\ufe0f\u200d\s]*/;
    qsa('.cl-prose, .cl-c-prose, .cl-acc__a, .rte').forEach(function (box) {
      qsa('h1, h2, h3, h4, h5, h6, th, strong, b', box).forEach(function (el) {
        var n = el.firstChild;
        while (n && n.nodeType !== 3 && n.firstChild) n = n.firstChild;
        if (n && n.nodeType === 3 && re.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(re, '');
      });
      qsa('table', box).forEach(function (t) {
        t.removeAttribute('width'); t.removeAttribute('height');
        t.style.width = ''; t.style.height = '';
        qsa('td, th, col, colgroup', t).forEach(function (c) { c.removeAttribute('width'); c.removeAttribute('height'); c.style.width = ''; c.style.height = ''; });
        if (!t.parentElement.classList.contains('cl-tablewrap')) {
          var w = document.createElement('div'); w.className = 'cl-tablewrap';
          t.parentNode.insertBefore(w, t); w.appendChild(t);
        }
      });
    });
  }

  function boot() {
    [initRichText, initAnn, initHeader, initSliders, initExplore, initHero, initFaq, initGallery, initProduct, initCart, initPopup].forEach(function (fn) {
      try { fn(); } catch (err) { if (window.console) console.error('Calm Leaf init failed:', err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
